<template>
  <div class="base-view">
    <div v-if="authenticating" class="authenticating">
      <span>Authenticating...</span>
    </div>
    <div v-else-if="!authenticated" class="login">
      <div class="panel">
        <h1>Login</h1>
        <div class="field">
          <input type="password" placeholder="password" v-model="password" @input="savePassword">
        </div>
        <div class="field">
          <input type="password" placeholder="authorization" v-model="authorization" @input="saveAuthorization">
        </div>
        <div class="field">
          <button @click="validate">Authenticate</button>
        </div>
      </div>
    </div>
    <div class="view" v-else>
      <div class="navbar">
        <ul>
          <li>
            {{role}}
          </li>
          <li>
            <router-link to="/">Home</router-link>
          </li>
          <li>
            <router-link to="/shows">Shows</router-link>
          </li>
          <li v-if="role === 'admin'">
            <router-link to="/upload">Upload</router-link>
          </li>
        </ul>
      </div>
      <router-view class="view"></router-view>
    </div>
  </div>
</template>

<script>

import config from '../config'

const password = localStorage.getItem('password');
const authorization = localStorage.getItem('authorization');

export default {
  name: "BaseView",
  data() {
    return {
      password: localStorage.getItem('password') || '',
      authorization: localStorage.getItem('authorization') || '',
      adminPassword: localStorage.getItem('admin_password') || '',
      authenticated: false,
      authenticating: true,
      role: 'geust'
    };
  },
  methods: {
    savePassword() {
      localStorage.setItem('password', this.password);
    },
    saveAuthorization() {
      localStorage.setItem('authorization', this.authorization)
    },
    validate() {
      this.authenticating = true;
      const authorization = localStorage.getItem('authorization');
      const password = localStorage.getItem('password');
      const admin_password = localStorage.getItem('admin_password');

      if (!authorization) {
        this.authenticated = false;
        return;
      }

      this.axios.get(`${config.api}/validate`, {
        headers: {
          password,
          authorization,
          admin_password
        }
      })
        .then((result) => {
          this.authenticated = true;
          this.authenticating = false;
          this.role = result.data.role;
        })
        .catch(() => {
          this.authenticated = false;
          this.authenticating = false;
        })
    }
  },
  created() {
    this.validate();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.base-view {
  height: 100vh;
}

.view {
  padding: 20px;
}

.authenticating {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.authenticating > span {
  font-size: 25px;
  font-weight: 700;
}

.login {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/BaseView.vue